import options from './permissions.component';

export default {
    selector: 'dtPermissions',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/permissions/index.js